import { useQuery } from "react-query";
import { useLogs } from "./useLogs";

export const useGetIvideonEventTypes = () => {
  const { getIvideonEventTypes } = useLogs();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["getIvideonEventTypes"],
    queryFn: () => getIvideonEventTypes(),
  });
  return { data: data?.data, isLoading, isError };
};
